import { useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import {
  Card,
  Grid,
  Box,
  Typography,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@material-ui/core";
import componentStyles from "assets/theme/views/admin/react-bs-table.js";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";


const useStyles = makeStyles(componentStyles);

export default function ContactHistory({ isMobile500, contactHistoric }) {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Grid
      container
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "baseline",
      }}
    >
      <Grid item xs={12}>
        <Card classes={{ root: classes.cardRoot }} style={{ display: "flex" }}>
          <Grid item xs={12} style={{ marginTop: "0.75rem" }}>
            <Box component={Typography} variant="h3" marginBottom="0!important">
              <Box component="span">Histórico de Contatos</Box>
            </Box>
          </Grid>
          <Divider style={{ margin: "0.85rem 0" }} />
          <Grid item xs={12}>
            {contactHistoric?.map((item) => (
              <Accordion
                key={item?.id}
                expanded={expanded === item?.id}
                onChange={handleChange(item?.id)}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <div
                    role="presentation"
                    style={{
                      display: "flex",
                      flexDirection: isMobile500 ? "column" : "row",
                    }}
                  >
                    <Typography
                      variant="body2"
                      style={{ margin: isMobile500 ? 0 : "0 1rem" }}
                    >
                      <span style={{ fontWeight: "600" }}>Canal: </span> App
                    </Typography>
                    <Typography variant="body2">
                      <span style={{ fontWeight: "600" }}>Data: </span>
                      {item?.date}
                    </Typography>
                  </div>
                </AccordionSummary>
                <AccordionDetails
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <Divider style={{ marginBottom: "0.75rem" }} />
                  <Grid
                    item
                    xs={12}
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <Typography
                      variant="body2"
                      style={{
                        fontSize: "0.95rem",
                        fontWeight: "650",
                        marginBottom: "0.6rem",
                      }}
                    >
                      Agenda de Contato:
                      <span style={{ fontWeight: "600", color: "green" }}>
                        {" "}
                        {item?.schedule}
                      </span>
                    </Typography>
                    <Typography variant="body2" style={{ fontSize: "0.85rem" }}>
                      Loja: {item?.store}
                    </Typography>
                    <Typography
                      variant="body2"
                      style={{ fontSize: "0.85rem", margin: "0.4rem 0" }}
                    >
                      Vendedor: {item?.seller}
                    </Typography>
                    <Typography variant="body2" style={{ fontSize: "0.85rem" }}>
                      Status: {item?.status}
                    </Typography>
                    <Typography
                      variant="body2"
                      style={{ fontSize: "0.85rem", margin: "0.4rem 0" }}
                    >
                      Modo de Contato: {item?.contactMode}
                    </Typography>
                    <Typography variant="body2" style={{ fontSize: "0.85rem" }}>
                      Termômetro: {item?.thermometer}
                    </Typography>
                    <Typography
                      variant="body2"
                      style={{ fontSize: "0.85rem", margin: "0.4rem 0" }}
                    >
                      Observação: {item?.characteristic}
                    </Typography>
                  </Grid>
                  <Divider style={{ margin: "0.7rem 0" }} />
                </AccordionDetails>
              </Accordion>
            ))}
          </Grid>
        </Card>
      </Grid>
    </Grid>
  );
}
